module.exports = __webpack_public_path__ + "img/marketplace.c976e4cc.svg";